module.exports = {
    licence:{
        Robot_problem_solved:'Fue de ayuda',
        Robot_problem_unsolved:'No fue de ayuda',
        Robot_emptyMassege_reminder:"No se puede enviar un mensaje vacío",
        Robot_massege_ViewMore:'Ver más',
        Robot_massege_ViewLess:'Ver menos',
        Robot_greetings_1:'Hola, ¿qué puedo hacer hoy por usted?',
        Robot_greetings_2:'¿Busca algo más? Intente escribir una palabra clave para que pueda buscar más información útil para usted.',
        Robot_closing_1_1:'Aww, lo siento! Todavía estoy aprendiendo.',
        Robot_closing_1_2:'Por favor, intente utilizar otra palabra clave, o simplemente haga clic',
        Robot_closing_1_login_1:"Aww, lo siento! Todavía estoy aprendiendo.",
        Robot_closing_1_login_2:' Por favor, intenta usar otra palabra clave!',
        Robot_closing_2:'AQUÍ ',
        Robot_closing_3:'para ponerse en contacto con nuestro servicio de atención al cliente. Le contestaremos lo antes posible.',
        Robot_problem_unsolved_reply:'Sentimos no haber podido ayudarle. He escrito su petición para que podamos mejorar nuestro servicio de atención al cliente. Por favor, haga clic AQUÍ para ponerse en contacto con nuestro servicio de atención al cliente. Le contestaremos lo antes posible.',
        Robot_TypeHere:'Escriba aquí',
        Robot_greetings_label1:'Combinar datos en la nueva aplicación',
        Robot_greetings_label2:'Pérdida de datos tras la migración',
        Robot_greetings_label3:'La báscula se desconecta tras la migración',
        Robot_greetings_label4:'Consejos para después de la migración',
        Robot_greetings_label5:'Gráficos que se muestran en la tarjeta',
        Robot_greetings_label6:"Ver historial de peso",
        Robot_greetings_label7:"Ver historial de circunferencia",
        Robot_greetings_label8:'Dónde puedo obtener ayuda',
        Robot_greetings_label9:'Otros',
        key_internet_error:"Hay problemas con la red. Por favor, compruebe la configuración de su red",
        Robot_title_Beta:'ChatBot',
        Robot_greetings_label1_login:'Contraseña olvidada',
        Robot_greetings_label2_login:'¿Cómo se reinicia la contraseña?',
        Robot_greetings_label3_login:'Combinar datos en la nueva aplicación',
        Robot_greetings_label4_login:'¿Por qué hay dos aplicaciones?',
        Robot_greetings_label5_login:'Notas de inicio de sesión de la cuenta',
        Robot_greetings_label6_login:"¿Hace falta registrarse otra vez en la nueva aplicación?",
        Robot_greetings_label7_login:"¿Qué hago si tengo cuentas en ambas aplicaciones?",
        Robot_greetings_label8_login:'Dónde puedo obtener ayuda',
        Robot_greetings_label9_login:'Otros',
        Robot_greetings_label1_devicePage:'Daten in der neuen App zusammenführen',
        Robot_greetings_label2_devicePage:'Datenverlust nach der Migration',
        Robot_greetings_label3_devicePage:'Die Waage ist nach der Migration nicht mehr angeschlossen',
        Robot_greetings_label4_devicePage:'Diagramm zur Gewichtstrends anzeigen',
        Robot_greetings_label5_devicePage:'Wechseln Sie zu einem anderen Messbenutzer',
        Robot_greetings_label6_devicePage:"Daten eines Freundes anzeigen",
        Robot_greetings_label7_devicePage:"Gewichtsdaten werden nicht mit der APP synchronisiert",
        Robot_greetings_label8_devicePage:'Wo bekomme ich Hilfe',
        Robot_greetings_label9_devicePage:'Anderen Fragen',
        Robot_greetings_label1_mePage:'¿Cómo puedo cambiar al usuario principal?',
        Robot_greetings_label2_mePage:'¿Cómo se edita la información del usuario principal?',
        Robot_greetings_label3_mePage:'Ver historial de amistad',
        Robot_greetings_label4_mePage:'Añadir a un amigo',
        Robot_greetings_label5_mePage:'¿Cómo enviar una solicitud de amistad?',
        Robot_greetings_label6_mePage:"¿Cómo comprobar una solicitud de amistad?",
        Robot_greetings_label7_mePage:"Borrar a un amigo",
        Robot_greetings_label8_mePage:'Dónde puedo obtener ayuda',
        Robot_greetings_label9_mePage:'Otros',
        Robot_greetings_label1_balancePage:'Los datos de peso no se sincronizan con la APP',
        Robot_greetings_label2_balancePage:'¿Cómo comprobar el error de Bluetooth?',
        Robot_greetings_label3_balancePage:'La aplicación solo muestra el peso y el IMC',
        Robot_greetings_label4_balancePage:'Las lecturas musculares se muestran en “--”',
        Robot_greetings_label5_balancePage:'La báscula pesa incorrectamente',
        Robot_greetings_label6_balancePage:"El porcentaje de grasa corporal cambia drásticamente",
        Robot_greetings_label7_balancePage:"Introduzca los datos de pesaje manualmente",
        Robot_greetings_label8_balancePage:'Cambie a otro usuario de medición',
        Robot_greetings_label9_balancePage:'Otros',
        Robot_greetings_label1_tapPage:'¿Cómo utilizar la medición de la cinta?',
        Robot_greetings_label2_tapPage:'Cambie a otro usuario en medición',
        Robot_greetings_label3_tapPage:'Ver gráfico de tendencias de circunferencia',
        Robot_greetings_label4_tapPage:'Ver historial de circunferencia',
        Robot_greetings_label5_tapPage:'Introducir datos de circunferencia manualmente',
        Robot_greetings_label6_tapPage:"Dónde puedo obtener ayuda",
        Robot_greetings_label7_tapPage:"Otros",
        savetoAlbum: 'Se ha guardado en el álbum',
        key_cancel: 'Cancelar',
        key_confirm: 'Confirmar',
        key_deleted: 'Se ha sido borrado con éxito',
        key_delete_popup: 'El historial no se mantendrá después del borrado. Asegúrese de que quiere borrarlo.',
        key_delete_history: 'Borrar historial del chat',
        key_delete_confirmation: 'Borrar confirmación'


    }
}